import React, { useContext, useEffect, useReducer } from 'react';
import UserContext from '../../context/UserContext.js';
import EditarItemLista from './EditarItemLista.js';
import CuadroTablaInsertable from '../UI/CuadroTablaInsertable.js';
import TablaDatos from '../UI/TablaDatos.js';
import * as ReducerEdicion from '../reducers/ReducerEdicionLista.js';
import * as ReducerData from '../reducers/ReducerDataAccess.js';
import styles from './CuadroListaEditable.module.css';
import MensajeGrabando from '../UI/MensajeGrabando.js';

const CuadroListaEditable = (props) => {
  const titulo = props.titulo;
  const idPadre = props.idPadre;
  const tipo = props.tipo;
  const data = props.data;
  const dtos = props.dtos;
  const funciones = props.funciones;
  const contexto = props.contexto;
  const ocultarSiVacio = props.ocultarSiVacio; // Nueva prop para ocultar si no hay datos en modo consulta
  const { usuario } = useContext(UserContext);
  const puedeEditar = usuario && usuario.puedeEditar;
  const [datos, setDatos] = useReducer(
    ReducerEdicion.reducerEdicionLista,
    ReducerEdicion.ReducerVacio
  );
  const [dataAccess, setDataAccess] = useReducer(
    ReducerData.reducerDataAccess,
    ReducerData.ReducerVacio
  );

  useEffect(() => {
    const cargarLista = async () => {
      setDataAccess({ type: ReducerData.Accion.CARGANDO, value: true });
      try {
        const lista = await data.GetListaItems(idPadre);
        if (lista && lista !== Promise.resolve(lista)) {
          // Ordenar la lista al cargarla
          const listaOrdenada = [...lista].sort((a, b) => funciones.OrdenarLista(a, b));
          setDatos({ type: ReducerEdicion.Tipo.LISTA, value: listaOrdenada });
        }
        setDataAccess({ type: ReducerData.Accion.LIMPIAR, value: null });
      } catch (error) {
        setDataAccess({ type: ReducerData.Accion.ERRORES, value: [error.message] });
      }
    };
    if (idPadre === null) {
      setDatos({ type: ReducerEdicion.Tipo.BORRAR, value: null });
      setDataAccess({ type: ReducerData.Accion.LIMPIAR, value: null });
    } else {
      cargarLista();
    }
  }, [idPadre, data, funciones]);

  const onCampoChange = (item) => {
    setDatos({ type: ReducerEdicion.Tipo.UPDATE_ITEM, value: item });
  };

  const onEditarItem = async (idItem) => {
    try {
      const itemElegido = await data.GetItem(idPadre, idItem);
      if (itemElegido && itemElegido !== Promise.resolve(itemElegido)) {
        setDatos({ type: ReducerEdicion.Tipo.EDITAR, value: itemElegido });
      }
    } catch (error) {
      setDataAccess({ type: ReducerData.Accion.ERRORES, value: [error.message] });
    }
  };

  const onEliminarItem = async (idItem) => {
    const eliminar = window.confirm('¿Está seguro que desea eliminarlo?');
    if (eliminar) {
      setDataAccess({ type: ReducerData.Accion.GRABANDO, value: true });
      try {
        await data.DeleteItem(idPadre, idItem);
        onItemEliminado(idItem);
        setDataAccess({ type: ReducerData.Accion.LIMPIAR, value: null });
      } catch (error) {
        setDataAccess({ type: ReducerData.Accion.ERRORES, value: [error.message] });
      }
    } else {
      setDataAccess({ type: ReducerData.Accion.LIMPIAR, value: null });
    }
  };

  const onInsertarItem = () => {
    let nuevoItem = dtos.ItemVacio(idPadre);
    setDatos({ type: ReducerEdicion.Tipo.INSERTAR, value: nuevoItem });
    setDataAccess({ type: ReducerData.Accion.LIMPIAR, value: null });
  };

  const onItemEliminado = (idEliminado) => {
    let nombres = ReducerEdicion.eliminarItemLista(datos, idEliminado);
    setDatos({ type: ReducerEdicion.Tipo.LISTA_ACTUALIZADA, value: nombres });
    // Notificar al padre si hay callback
    if (props.onListaActualizada) {
      props.onListaActualizada();
    }
  };

  const onItemGrabado = (itemGrabado) => {
    let listaNueva = ReducerEdicion.listaActualizada(datos, itemGrabado);
    const listaOrdenada = listaNueva.sort((a, b) => funciones.OrdenarLista(a, b));
    setDatos({ type: ReducerEdicion.Tipo.LISTA_ACTUALIZADA, value: listaOrdenada });
    // Notificar al padre si hay callback
    if (props.onListaActualizada) {
      props.onListaActualizada();
    }
  };

  const onCancelarEditarItem = () => {
    setDatos({ type: ReducerEdicion.Tipo.CANCELAR, value: null });
    setDataAccess({ type: ReducerData.Accion.LIMPIAR, value: null });
  };

  // Si ocultarSiVacio=true, no renderizar en modo consulta cuando no hay datos
  if (ocultarSiVacio && !puedeEditar && (!datos.lista || datos.lista.length === 0)) {
    return null;
  }

  return (
    <CuadroTablaInsertable
      titulo={titulo}
      isCargando={dataAccess.cargando}
      errores={dataAccess.errores}
      onInsertar={onInsertarItem}
    >
      {!dataAccess.cargando && (
        <TablaDatos
          estilo={`${styles.tablaDatos}`}
          lista={datos.lista}
          textoVacia="No hay datos a mostrar"
        >
          <tbody>
            {funciones.armarFilasTabla(
              datos.lista,
              datos.itemEdicion && datos.itemEdicion.id,
              onEditarItem,
              onEliminarItem
            )}
          </tbody>
        </TablaDatos>
      )}
      <MensajeGrabando isGrabando={dataAccess.grabando} />
      {puedeEditar && (
        <EditarItemLista
          tipo={tipo}
          idPadre={idPadre}
          modo={datos.modo}
          item={datos.itemEdicion}
          actualizar={datos.actualizarItem}
          funciones={funciones}
          data={data}
          contexto={contexto}
          onCampoChange={onCampoChange}
          onItemGrabado={onItemGrabado}
          onItemEliminado={onItemEliminado}
          onCancelar={onCancelarEditarItem}
        />
      )}
    </CuadroTablaInsertable>
  );
};

export default CuadroListaEditable;
